export const Languages = [
    {
        key: "en",
        text: 'English',
        value: "en"
    }
]